import { memo } from "react";
import district from "../../../assets/district.png";
import laoCountry from "../../../assets/lao-country.png";
import hospital from "../../../assets/hospital.png";
import districtHospital from "../../../assets/district-hospital-b.png";
import healthCenter from "../../../assets/health-center-b.png";
import IndicatorValue from "../components/IndicatorValue";
import CustomWidget from "./CustomWidget";

const iconStyle = {
  fontSize: 30,
  color: "#555",
};

const WidgetOverall = ({ teiData, listProvince }) => {
  return (
    <div className="top-widget-container">
      <CustomWidget title="Provinces reported:">
        <IndicatorValue
          data={18}
          icon={
            <div style={{ marginRight: 20 }}>
              <img src={laoCountry} width={60} height={60} />
            </div>
          }
          // unit="(per 100.000)"
        />
      </CustomWidget>
      <CustomWidget title="Districts reported:">
        <IndicatorValue
          data={148}
          icon={
            <div style={{ marginRight: 20 }}>
              <img src={district} width={60} height={60} />
            </div>
          }
          // unit="(per 100.000)"
        />
      </CustomWidget>
      <CustomWidget title="Provincial Hospitals Reported:">
        <IndicatorValue
          data={17}
          icon={
            <div style={{ marginRight: 20 }}>
              <img src={hospital} width={60} height={60} />
            </div>
          }
          // unit="(per 100.000)"
        />
      </CustomWidget>
      <CustomWidget title="District Hospitals Reported:">
        <IndicatorValue
          data={134}
          icon={
            <div style={{ marginRight: 20 }}>
              <img src={districtHospital} width={60} height={60} />
            </div>
          }
          // unit="(per 10.000)"
        />
      </CustomWidget>
      <CustomWidget title="Health Centres reported:">
        <IndicatorValue
          data={1222}
          icon={
            <div style={{ marginRight: 20 }}>
              <img src={healthCenter} width={60} height={60} />
            </div>
          }
          // unit="(per 10.000)"
        />
      </CustomWidget>
    </div>
  );
};

export default memo(WidgetOverall);
